module.exports = __webpack_public_path__ + "media/images/features/draft/thumb-voice-2-eb5182a89917d248caadccbde8f601a3.jpg";